import Axios from 'axios';
const ZOOM = 15;
export class MapService {
  private readonly API_KEY = 'AIzaSyCGBglgsdHWGfmQ48jtSYLbtdZXO-Pe65Q';
  private readonly geoCodeBaseURL =
    'https://maps.googleapis.com/maps/api/geocode/json';
  private readonly staticMapBaseURL =
    'https://maps.googleapis.com/maps/api/staticmap';

  public async getStaticMapImage(address: string) {
    const encodedAdress = address.replace(' ', '+');
    const geoCodeResponse = await Axios.get(
      `${this.geoCodeBaseURL}?address=${encodedAdress}&key=${this.API_KEY}`
    );
    if (
      geoCodeResponse &&
      geoCodeResponse.data &&
      geoCodeResponse.data.results &&
      geoCodeResponse.data.results[0] &&
      geoCodeResponse.data.results[0].geometry &&
      geoCodeResponse.data.results[0].geometry.location
    ) {
      const { lat, lng } = geoCodeResponse.data.results[0].geometry.location;
      return `${this.staticMapBaseURL}?size=415x300&markers=${lat},${lng}&zoom=${ZOOM}&key=${this.API_KEY}`;
    }
    throw new Error('location not found');
  }
}

const mapService = new MapService();
export default mapService;
